<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('aboutus-main')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New About-Us</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="title"
        >
        </base-input>
        <base-input
          alternative
          class="mb-3"
          name="Link"
          :rules="{ required: true }"
          placeholder="link"
          v-model="link"
        >
        </base-input>
        <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        />

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";
import { link } from "fs";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      image: null,
      coverImage: null,
      body: "",
      link: "",
      buttonName: "",
      redirectTo: "",
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      typeOption: [
        {
          value: "main",
          label: "Main",
        },
        {
          value: "other",
          label: "Other",
        },
      ],
      msg: {},
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      console.log(this.user, "User");
      let FormData = require("form-data");
      let data = new FormData();
      data.append("heading", this.title);
      // data.append("image", this.coverImage);
      data.append("description", this.body);
      data.append("link", this.link);
      data.append("_id", this.user._id);
      let loader = this.$loading();

      try {
        const blogdata = await this.$store.dispatch(
          "mainAboutUs/add_aboutUs",
          data
        );
        // if (blogdata.code == 200) {
        this.$router.push({ name: "aboutus-main" });
        this.$swal.fire({
          title: "Congratulations!",
          text: "Your content has been successfully added to the website",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
